/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Station_Voice_TitleInputs */

const vi_station_voice_title = /** @type {(inputs: Station_Voice_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cấu hình lời thoại máy trạm`)
};

/**

* @param {Station_Voice_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_voice_title = /** @type {((inputs?: Station_Voice_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_Voice_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_voice_title(inputs)
});